/**
 * @fileoverview POST handler for the "/alloys/shopify/:app_group_id/bridges/:bridge_id/catalog_resync" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { alloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncCacheKeys } from "./constants";
import type {
  PostAlloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncProps,
  AlloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncResult,
} from "./types";

export const postAlloysShopifyAppGroupIdBridgesBridgeIdCatalogResync = reactQueryMutationAdapter(
  alloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncCacheKeys,
  (
    props: PostAlloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncProps
  ): Promise<AlloysShopifyAppGroupIdBridgesBridgeIdCatalogResyncResult> => {
    // manipulate props here as needed {  }

    return fetch(
      `/alloys/shopify/${props.appGroupId}/bridges/${props.bridgeId}/catalog_resync`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors, handled by toast instead
        propagateFetchRequestError: false,
      }
    );
  }
);
